// extracted by mini-css-extract-plugin
export default {"fixed":"DefaultToast_fixed--Q3w","toast":"DefaultToast_toast--zT2"};